<mat-card-content class="w-100-p mb-0" (click)="openTeamBookingsPage()">
    <div class="p-24 stats-wrapper">
        <div fxLayout="column" class="chart-wrapper w-100-p">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="chart-title-wrapper mb-8 w-100-p">
                <div class="w-100-p" fxLayoutAlign="space-between center">
                    <div fxLayout="row">
                        <div fxLayoutAlign="center center" class="icon-wrapper mr-8">
                            <img class="team-bookings-icon" src="assets/icons/ic_bookings.svg" alt="" />
                        </div>
                        <label fxLayout="row" fxLayoutAlign="flex-start center" class="chart-title" tabindex="0">
                            {{ 'NAV.BOOKINGS.TITLE' | translate }}
                        </label>
                    </div>
                    <div fxLayoutAlign="flex-end center">
                        <mat-icon svgIcon="right_arrow"></mat-icon>
                    </div>
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="center center" fxFlex="1 1 auto" class="bg-zinc-50 text-xs leading-5 min-w-2 text-gray-600 text-center tracking-widest uppercase">
                <span tabindex="0">{{ bookingsTeamOverview?.openBookingRequestCount }}&nbsp;</span>
                <span>{{ 'LISTINGS.LABEL.OPEN_BOOKING_REQUESTS' | translate }}</span>
            </div>
        </div>
    </div>
</mat-card-content>
